// @ts-nocheck
import { geocodeAddress } from '../lib/maps/placesClient';

export type LatLng = { lat: number; lng: number };

const geocodeCache = new Map<string, LatLng | null>();

export function haversineKm(a: LatLng, b: LatLng): number {
  const R = 6371; // km
  const dLat = (b.lat - a.lat) * Math.PI / 180;
  const dLng = (b.lng - a.lng) * Math.PI / 180;
  const lat1 = a.lat * Math.PI / 180;
  const lat2 = b.lat * Math.PI / 180;
  const h = Math.sin(dLat/2)**2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng/2)**2;
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
}

export async function geocodeCached(query: string): Promise<LatLng | null> {
  const q = (query || '').trim();
  if (!q) return null;
  if (geocodeCache.has(q)) return geocodeCache.get(q)!;
  try {
    const res = await geocodeAddress(q);
    geocodeCache.set(q, res || null);
    return res || null;
  } catch {
    geocodeCache.set(q, null);
    return null;
  }
}

export function getUserLocation(): Promise<LatLng | null> {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      () => resolve(null),
      { enableHighAccuracy: false, maximumAge: 60000, timeout: 8000 }
    );
  });
}

export async function distanceKmToQuery(from: LatLng, query: string): Promise<number | null> {
  const to = await geocodeCached(query);
  if (!to) return null;
  return haversineKm(from, to);
}

export function formatDistanceKm(km?: number | null): string | null {
  if (km == null) return null;
  if (km < 1) return `${Math.round(km * 1000)} m`;
  if (km < 10) return `${km.toFixed(1)} km`;
  return `${Math.round(km)} km`;
}

/** Format distance based on locale; mi for en-US, km otherwise */
export function formatDistanceLocalized(km?: number | null, locale?: string): string | null {
  if (km == null) return null;
  const loc = (locale || (typeof navigator !== 'undefined' ? navigator.language : ''))?.toLowerCase?.() || '';
  const isUS = loc.includes('en-us');
  if (!isUS) {
    return formatDistanceKm(km);
  }
  const miles = km * 0.621371;
  if (miles < 1) return `${miles.toFixed(2)} mi`;
  if (miles < 10) return `${miles.toFixed(1)} mi`;
  return `${Math.round(miles)} mi`;
}
